import React from 'react';
import '../styles/SpeedSlider.css';

const SpeedSlider = ({ speed, onSpeedChange, disabled }) => {
  return (
    <div className="speed-slider-container">
      <label htmlFor="speed-slider" className="speed-label">
        Velocidad: <span className="speed-value">{speed.toFixed(1)}s</span>
      </label>
      <input
        id="speed-slider"
        type="range"
        min="0.5"
        max="5"
        step="0.1"
        value={speed}
        onChange={(e) => onSpeedChange(parseFloat(e.target.value))}
        disabled={disabled}
        className="slider"
      />
      <div className="speed-labels">
        <span>0.5s</span>
        <span>5s</span>
      </div>
    </div>
  );
};

export default SpeedSlider;
